<template>
  <b-row>
    <b-col cols="12">
      <b-badge variant="info" class="mb-2">
        Tracking Number: {{ trackingNumber }}
      </b-badge>
      <CFBeneficialOwnersV2
        :task-data="data"
        :tracking-number="trackingNumber"
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";
import CFBeneficialOwnersV2 from "@/views/home/commons/CFBeneficialOwnersV2.vue";

export default {
  name: "ContinuousChangeBeneficialOwners",
  components: {
    CFBeneficialOwnersV2
  },
  props: {
    data: Object
  },
  computed: {
    ...mapGetters(["getContinuousFilingTask"]),
    trackingNumber() {
      return (
        this.getContinuousFilingTask?.data?.trackingNo ||
        this.getContinuousFilingTask?.data?.form?.trackingNo ||
        this.data?.trackingNo ||
        this.data?.form?.trackingNo ||
        ""
      );
    }
  }
};
</script>

<style scoped>
</style>